// Debug script for product-form issues
console.log('=== Product Form Debug Script Loaded ===');

// Check if product-form element exists
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM Content Loaded');
  
  const productForms = document.querySelectorAll('product-form');
  console.log('Found product-form elements:', productForms.length);
  
  productForms.forEach((form, index) => {
    console.log(`Product Form ${index}:`, form);
    
    const htmlForm = form.querySelector('form');
    console.log(`  - Has form element:`, !!htmlForm);
    
    const submitButton = form.querySelector('[type="submit"]');
    console.log(`  - Has submit button:`, !!submitButton);
    console.log(`  - Button disabled:`, submitButton?.disabled);
    console.log(`  - Button aria-disabled:`, submitButton?.getAttribute('aria-disabled'));
    
    const variantId = form.querySelector('[name="id"]');
    console.log(`  - Variant ID input:`, variantId?.value);
    console.log(`  - Variant ID disabled:`, variantId?.disabled);
    
    // Check if form has event listeners
    if (htmlForm) {
      console.log(`  - Form has submit listener attached`);
      
      // Add a test listener to see if events are firing
      htmlForm.addEventListener('submit', function(e) {
        console.log('!!! FORM SUBMIT EVENT FIRED !!!');
        console.log('Event:', e);
      }, true); // Use capture phase to catch it first
    }
    
    if (submitButton) {
      submitButton.addEventListener('click', function(e) {
        console.log('!!! SUBMIT BUTTON CLICKED !!!');
        console.log('Button:', this);
        console.log('Disabled:', this.disabled);
        console.log('Aria-disabled:', this.getAttribute('aria-disabled'));
      }, true);
    }
  });
  
  // Check for cart elements
  const cartDrawer = document.querySelector('cart-drawer');
  const cartNotification = document.querySelector('cart-notification');
  console.log('Cart Drawer exists:', !!cartDrawer);
  console.log('Cart Notification exists:', !!cartNotification);
  
  // Check routes
  console.log('Window routes:', window.routes);
  
  // Check if fetchConfig exists
  console.log('fetchConfig function exists:', typeof fetchConfig !== 'undefined');
});
